import {
    ColoursObj,
    LoadingSpinner,
    MainButton,
    Typography,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { useEphemeralStore } from '../../../state/useEphemeralStore'
import { HotelAvailCard } from './hotelAvailCard'

export const HotelDetailsAvailability: FC = () => {
    const { hotelResp } = useEphemeralStore(
        useShallow((s) => ({
            hotelResp: s.hotelResp,
        }))
    )

    if (!hotelResp || !hotelResp.rates) {
        return (
            <Box padding={'16px'}>
                <LoadingSpinner />
            </Box>
        )
    }

    if (!hotelResp.rates.rates || hotelResp.rates.rates.length < 1) {
        return (
            <Box
                display={'grid'}
                maxWidth={'90vw'}
                borderTop={'1px solid ' + ColoursObj.shades.shade2}
                padding={'16px 0 0 0'}
                margin={'16px 0 16px 0'}
                justifyItems={'center'}
            >
                <Typography>{i18n.t('booking.noAvail')}</Typography>
            </Box>
        )
    }

    return (
        <Box
            display={'grid'}
            maxWidth={'90vw'}
            borderTop={'1px solid ' + ColoursObj.shades.shade2}
            padding={'16px 0 0 0'}
            margin={'16px 0 16px 0'}
            gap={'16px'}
        >
            <Box>
                <Typography variant="desktopH3">
                    {i18n.t('booking.avail')}
                </Typography>
            </Box>
            <Box>
                <HotelAvailCard
                    key={'availCard1'}
                    rate={hotelResp.rates.rates[0]}
                />
            </Box>
            <MainButton
                text={i18n.t('booking.seeAvail')}
                onClick={() => {
                    window.pushPath('/edit/hotelbooking/avail')
                }}
                icon="Right"
                iconPosition="right"
            />
            <Box height={'32px'} />
        </Box>
    )
}
